
/**
 * @export
 * @type DailyUserHistoryEvent
 */
export type DailyUserHistoryEvent = {
    /**
     * The unique identifier of the affected user
     */
    userId: number;
    /**
     * The type of action that occurred
     */
    actionType?: DailyUserHistoryEventActionType;
    /**
     * Email address of the affected user
     */
    email: string;
    /**
     * Unique identifier of the changelog entry
     */
    logId: string;
    /**
     * The unique identifier of the user who initiated the action, if applicable
     */
    initiatorUserId?: number | null;
    /**
     * Email address of the user who initiated the action, if applicable
     */
    initiatorUserEmail?: string | null;
    /**
     * The system that initiated the action (e.g. admin, API)
     */
    initiatorSystem?: string;
    /**
     * The reason or description for the user change
     */
    reason?: string;
    /**
     * UTC timestamp when the event occurred
     */
    timestamp: string;
    /**
     * The user\'s type at the time of the event. Allowed values: Licensed, Mobile, CRM, Credit Alerts, Virtual, No Access, Free Newsletter
     */
    userType: string;
    /**
     * The affected user\'s current status, with EMPTY used when no status is set
     */
    status: DailyUserHistoryEventStatus;
}

export enum DailyUserHistoryEventActionType {
    Exported = 'Exported',
    Imported = 'Imported',
    Created = 'Created',
    Updated = 'Updated'
}

export enum DailyUserHistoryEventStatus {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    SUSPENDED = 'SUSPENDED',
    EMPTY = 'EMPTY'
}